import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { ChangelogComponent } from './dialogs/changelog/changelog.component';

import { SidebarModule } from './shared/sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { CognitoGuardService } from './services/cognito/cognito-guard.service';
import { MaterialModule } from './material.module';
import { DevExtremeModule } from 'devextreme-angular';

import { ConfigurationService } from './services/configuration.service';
import { NotificationService } from './services/notification/notification.service';
import { NotificationEndpoint } from './services/notification/notification-endpoint.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { HttpClientModule } from '@angular/common/http';

// Commons services
import { AlertService } from './services/utilities/alert.service';
import { ToastrModule } from 'ngx-toastr';
import { DocumentationConfigurationService, DocumentationModule } from '@icadsistemi/ngx-icadsistemi-documentation-inline';
import { AuthGuard } from './services/auth/auth-guard.service';
import { ExternalLayoutComponent } from './layouts/external/external-layout/external-layout.component';
import { RolePermissionService } from './services/permissions/role-permission.service';
import { DesUtilities } from './utilities/des.utilty';
import { GlobalSupplierEndpoint } from './services/global-supplier/global-supplier.endpoint';
import { GlobalSupplierGuardService } from './services/guards/global-supplier-guard.service';

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot(AppRoutes, { relativeLinkResolution: 'legacy' }),
        HttpClientModule,
        MaterialModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        DevExtremeModule,
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        DocumentationModule,
    ],
    declarations: [ExternalLayoutComponent, AppComponent, AdminLayoutComponent, AuthLayoutComponent, ChangelogComponent],
    providers: [CognitoGuardService, AuthGuard, ConfigurationService, LocalStoreManager, NotificationService, NotificationEndpoint, AlertService, DesUtilities, DocumentationConfigurationService, RolePermissionService, GlobalSupplierEndpoint, GlobalSupplierGuardService],
    bootstrap: [AppComponent],
})
export class AppModule {}
